import React from 'react';
import PropTypes from 'prop-types';
import Navbar from 'components/navbar/Navbar';
import CollapsedSearchMask from 'components/CollapsedSearchMask';
import MetaResultsTabs from 'components/meta-results-tabs/index';
import SearchMask from 'components/SearchMask';
import navbarStore from 'components/navbar/NavbarStore';

function Results({collapseSearchMaskStore, searchMaskStore, resultsTabsStore}) {
  return (
    <div>
      <Navbar navbar={navbarStore} />
      <CollapsedSearchMask
        store={collapseSearchMaskStore}
      >
        <SearchMask store={searchMaskStore} />
      </CollapsedSearchMask>
      <div id='tabs-container'>
        <MetaResultsTabs store={resultsTabsStore}/>
      </div>
    </div>
  );
}

Results.propTypes = {
  collapseSearchMaskStore: PropTypes.object.isRequired,
  searchMaskStore: PropTypes.object.isRequired,
  resultsTabsStore: PropTypes.object.isRequired
};

export default Results;
